module.exports = __webpack_public_path__ + "img/pc-card-small-inactive.5f243efd.svg";